

























































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import OverlayWindow from "../general/OverlayWindow.vue";
import Loading from "../general/Loading.vue";

import ModulesJson from "../../shared/ModulesJson";
import MaterialItemJson, {
  defaultMaterialItemJson,
  validateMaterialItemJson,
  validateMaterialItemJsonAdd,
} from "../../shared/MaterialItemJson";

import { UserPermissionRank, UserPermissionRankNames } from "../../shared/UserPermissionRank";
import UserPermission, { defaultUserPermissionJson } from "../../shared/UserPermission";
import { UserPermissionType, UserPermissionTypeNames } from "../../shared/UserPermissionType";
import UserPermissionTypeInfoJson, { UserPermissionTypeInfos } from "../../shared/UserPermissionTypeInfoJson";

import { validateUserJson } from "../../shared/UserJson";
import { ValidationResult, Validation } from "../../shared/Validation";

export default Vue.extend({
  name: "SettingsMaterialItemForm",
  components: {
    OverlayWindow,
    Loading,
  },
  props: {
    restClient: RestClient,
    loginPermission: Number,
    allActiveModules: Array as PropType<ModulesJson[]>,
    mode: String,
    editable: Boolean,
    materialItemId: Number,
  },
  data() {
    return {
      detailsTitle: "",
      detailsMode: "",
      selectedId: null as number | null,
      details: null as MaterialItemJson | null,
      allMaterialItems: null as MaterialItemJson[] | null,
      hasChanges: false,
      toValidate: {} as any,
      validation: null as ValidationResult<MaterialItemJson> | null,
      submitValidation: false as boolean,
      frontendValidations: {
        title: false,
      },
      titleTimeout: null as any,
      loadingTitleAvailability: false as boolean,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.details = null;
      this.selectedId = this.materialItemId;
      this.loadAllMaterialItems();
      this.loadDetails();
    },

    async loadDetails() {
      if (this.selectedId != null) {
        if (this.restClient != null) {
          try {
            this.details = await this.restClient.getMaterialItem(this.selectedId);
          } catch (e) {
            alert(e.message);
          }
        }
      } else {
        this.details = this.getDefaultMaterialItemData();
      }

      this.$nextTick(() => {
        this.hasChanges = false;
      });
    },

    async loadAllMaterialItems() {
      if (this.restClient != null) {
        try {
          this.allMaterialItems = await this.restClient.getMaterialItems();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    getDefaultMaterialItemData() {
      return { ...defaultMaterialItemJson() };
    },

    closeDetails() {
      if (!this.hasChanges) {
        this.$emit("close");
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.$emit("close");
        } else {
          //do nothing
        }
      }
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.details != null) {
        this.validation = validateMaterialItemJson(this.details);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    checkFrontendValidations() {
      let check = true;

      let k = this.frontendValidations;
      let i: keyof typeof k;
      for (i in this.frontendValidations) {
        if (this.frontendValidations[i] == true) {
          check = false;
        }
      }

      return check;
    },

    async checkTitleAvailability(timeout: boolean = true) {
      this.loadingTitleAvailability = true;
      clearTimeout(this.titleTimeout);

      let vue = this;

      this.titleTimeout = setTimeout(
        async function () {
          if (vue.allMaterialItems != null && vue.details != null && vue.details.title != "") {
            let exists = vue.allMaterialItems.find((i: MaterialItemJson) => i.title == vue.details?.title);

            if (exists) {
              vue.frontendValidations.title = true;
              vue.loadingTitleAvailability = false;
            } else {
              vue.frontendValidations.title = false;
              vue.loadingTitleAvailability = false;
            }
          } else {
            vue.frontendValidations.title = false;
            vue.loadingTitleAvailability = false;
          }
        },
        timeout ? 600 : 0
      );
    },

    async addNewMaterialItem() {
      if (this.details != null) {
        this.loadingGeneral = true;

        this.submitValidation = true;

        this.checkTitleAvailability(false);

        this.validation = validateMaterialItemJsonAdd(this.details);

        if (this.validation != null && this.validation.isValid == true && this.checkFrontendValidations()) {
          if (this.restClient != null) {
            try {
              this.details = await this.restClient.addMaterialItem(this.details);
              this.hasChanges = false;
              this.loadingGeneral = false;
              this.closeDetails();
              alert("Das Material wurde erfolgreich hinzugefügt.");
            } catch (e) {
              this.loadingGeneral = false;
              alert(e.message);
            }
          }
        } else {
          this.loadingGeneral = false;
          alert("Das Material konnte nicht hinzugefügt werden. Bitte überprüfen Sie Ihre Angaben.");
        }
      }
    },

    async saveMaterialItem() {
      if (this.details != null) {
        if (this.hasChanges) {
          this.loadingGeneral = true;

          this.checkTitleAvailability(false);

          this.validation = validateMaterialItemJson(this.details);

          if (this.validation != null && this.validation.isValid == true && this.checkFrontendValidations()) {
            if (this.restClient != null) {
              try {
                this.details = await this.restClient.updateMaterialItem(this.details);
                this.hasChanges = false;
                this.loadingGeneral = false;
                alert("Die Änderungen wurden erfolgreich gespeichert.");
                this.closeDetails();
              } catch (e) {
                this.loadingGeneral = false;
                alert(e.message);
              }
            }
          } else {
            this.loadingGeneral = false;
            alert("Die Änderungen konnten nicht gespeichert werden. Bitte überprüfen Sie Ihre Änderungen.");
          }
        } else {
          alert("Es wurden keine Änderungen vorgenommen.");
          this.closeDetails();
        }
      }
    },

    async deleteMaterialItem() {
      if (this.selectedId != null) {
        let c = confirm("Wollen Sie dieses Material wirklich unwiderruflich löschen?");
        if (c == true) {
          if (this.restClient != null) {
            try {
              await this.restClient.deleteMaterialItem(this.selectedId);
              this.closeDetails();
              alert("Das Material wurde gelöscht.");
            } catch (e) {
              alert(e.message);
            }
          }
        } else {
          //do nothing
        }
      }
    },
  },
  watch: {
    details: {
      handler() {
        this.hasChanges = true;
      },
      deep: true,
    },

    materialItemId: {
      handler() {
        this.init();
      },
    },

    loadingGeneral: {
      handler() {
        this.$emit("loading", this.loadingGeneral || this.loadingTitleAvailability);
      },
    },

    loadingTitleAvailability: {
      handler() {
        this.$emit("loading", this.loadingGeneral || this.loadingTitleAvailability);
      },
    },
  },
  computed: {
    allCategories() {
      let categories: string[] = [];

      if (this.allMaterialItems != null) {
        categories = this.allMaterialItems.map((i) => i.category);
      }

      return [...new Set(categories)];
    },
  },
});
